import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import {Loader} from 'components';

import nextTick from 'helpers/nextTick';

import BranchApi from 'api/branch';
import ValidateGroup from 'helpers/validation';
import {injectIntl} from 'react-intl';

// TODO: i18n
let ALL = {value: 'All', label: 'All'};

class BranchSelect extends React.Component {
  static displayName = 'BranchSelect';

  static propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    group: PropTypes.instanceOf(ValidateGroup),
    style: PropTypes.object,
  };

  constructor(props) {
    super(props);

    ALL.label = props.intl.formatMessage({id: 'general.all'});

    this.state = {
      loaded: false,
      branches: [ALL],
      selectedBranches: [ALL],
      correct: true,
    };
  }

  componentWillMount() {
    this.fetchData();
  }

  componentDidMount() {
    if (this.props.group) {
      this.props.group.addComponent(this, false);
    }
  }

  getValue = () => {
    return this.parseValues(this.state.selectedBranches);
  };

  fetchData = () => {
    let apis = [];

    apis.push(BranchApi.getFullBranches());

    Promise.all(apis)
      .then(([branches]) => {
        let selectedBranches = [ALL];

        if (branches.length === 1) {
          selectedBranches = branches.map(x => ({label: x.name, value: x.id}));
        }
        this.setState({
          branches,
          loaded: true,
          selectedBranches,
        });
      });
  };

  focus = () => {
    if (this.inner) {
      this.inner.focus();
    }
  };

  parseValues = (vals) => {
    if (vals.length === 0) {
      return undefined;
    }

    let output = vals.map(x => x.value);

    if (output.includes(ALL.value)) {
      output = null;
    }

    return output;
  };

  switchBranch = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      this.setState({
        selectedBranches: [],
      });
      return;
    }

    // Ensure that 'All' cannot be selected along with other values in a multiselect
    if (Array.isArray(selectedOptions) && Array.isArray(this.state.selectedBranches)) {
      let prevIndexOfAll = this.state.selectedBranches.indexOf(ALL);
      let currentIdxOfAll = selectedOptions.indexOf(ALL);

      // If 'ALL' is being added to the selected options, then force it to be the only option selected
      if (currentIdxOfAll !== -1 && prevIndexOfAll === -1) {
        selectedOptions = [selectedOptions[currentIdxOfAll]];
      // Remove 'ALL', when the user is trying to add another option
      } else if (currentIdxOfAll !== -1 && selectedOptions.length > 1) {
        selectedOptions.splice(currentIdxOfAll, 1);
      }
    }

    let selected = Object.assign({}, this.state.selectedBranches);

    selected = selectedOptions;

    this.setState({
      selectedBranches: selected,
    });

    nextTick(() => {
      if (this.props.onChange) {
        this.props.onChange(this.parseValues(selected.map(x => x.value)));
      }
    });

    if (!this.state.correct) {
      this.validate(selected);
    }
  };

  validate = (vals = this.state.selectedBranches) => {
    let correct = false;

    if (!this.props.required || vals.length > 0 || this.state.branches.length === 0) {
      correct = true;
    }

    if (correct !== this.state.correct) {
      this.setState({correct});
    }

    return correct;
  };

  render() {
    let branchOptions = [ALL];

    if (this.state.loaded && this.state.branches) {
      branchOptions = branchOptions.concat(this.state.branches.map(({id, name}) => ({label: name, value: id})));
    }

    return <Loader loaded={this.state.loaded}>
      <div className='form-group' style={this.props.style}>
        {this.props.label ? <label>
          {this.props.label}
          {this.props.required ? <span className='error' style={{marginLeft: 2}}>*</span> : null}
        </label> : null}
        {branchOptions.length > 2 ? // This should be 2 since all is included as an option
          <ReactSelect name='branches' multi={true}
                       ref={r => this.inner = r}
                       className={this.state.correct ? '' : 'error'}
                       options={branchOptions}
                       placeholder={this.props.intl.formatMessage({id: 'general.select.store'})}
                       value={this.state.selectedBranches}
                       onChange={this.switchBranch} /> :
          this.state.selectedBranches.length > 0 ? <div>{this.state.selectedBranches[0].label}</div> : null
        }
      </div>
    </Loader>;
  }
}

export default injectIntl(BranchSelect, {withRef: true});
